import React from 'react';

const AnimatedBackground: React.FC = () => {
    return (
        <div className="absolute inset-0 bg-stone-100">
            {/* Floating Mathematical Elements */}
            <div className="absolute inset-0 overflow-hidden">
                {/* Floating Mathematical Symbols */}
                <div className="absolute top-10 left-10 text-6xl text-blue-200 animate-float-slow opacity-30">π</div>
                <div className="absolute top-32 right-20 text-4xl text-indigo-200 animate-float-medium opacity-25">∑</div>
                <div className="absolute top-64 left-1/4 text-5xl text-purple-200 animate-float-fast opacity-20">∞</div>
                <div className="absolute bottom-32 right-1/3 text-3xl text-cyan-200 animate-float-slow opacity-30">∫</div>
                <div className="absolute bottom-20 left-1/2 text-4xl text-pink-200 animate-float-medium opacity-25">√</div>

                {/* Additional Math Symbols */}
                <div className="absolute top-20 left-1/3 text-5xl text-blue-300 animate-float-medium opacity-25">=</div>
                <div className="absolute top-40 right-1/4 text-4xl text-indigo-300 animate-float-slow opacity-30">+</div>
                <div className="absolute top-80 left-1/5 text-3xl text-purple-300 animate-float-fast opacity-20">-</div>
                <div className="absolute bottom-40 left-1/4 text-4xl text-cyan-300 animate-float-medium opacity-25">×</div>
                <div className="absolute bottom-60 right-1/5 text-3xl text-pink-300 animate-float-slow opacity-30">÷</div>
                <div className="absolute top-1/3 right-1/6 text-2xl text-blue-400 animate-float-fast opacity-35">%</div>
                <div className="absolute bottom-1/3 left-1/6 text-3xl text-indigo-400 animate-float-medium opacity-25">±</div>
                <div className="absolute top-1/2 left-1/8 text-4xl text-purple-400 animate-float-slow opacity-20">≠</div>
                <div className="absolute bottom-1/2 right-1/8 text-3xl text-cyan-400 animate-float-fast opacity-30">≈</div>
                <div className="absolute top-1/4 right-1/3 text-2xl text-pink-400 animate-float-medium opacity-25">≤</div>
                <div className="absolute bottom-1/4 left-1/3 text-2xl text-blue-500 animate-float-slow opacity-30">≥</div>

                {/* Floating Geometric Shapes */}
                <div className="absolute top-20 right-1/4 w-8 h-8 border-2 border-blue-300 rounded-full animate-float-slow opacity-20"></div>
                <div className="absolute top-40 left-1/3 w-6 h-6 bg-indigo-300 transform rotate-45 animate-float-medium opacity-25"></div>
                <div className="absolute bottom-40 right-1/4 w-10 h-10 border-2 border-purple-300 transform rotate-12 animate-float-fast opacity-20"></div>
                <div className="absolute bottom-20 left-1/4 w-4 h-4 bg-cyan-300 rounded-full animate-float-slow opacity-30"></div>

                {/* Grid Pattern */}
                <div className="absolute inset-0 opacity-15">
                    <div className="grid grid-cols-12 grid-rows-8 h-full w-full">
                        {Array.from({ length: 96 }).map((_, i) => (
                            <div key={i} className="border border-stone-300"></div>
                        ))}
                    </div>
                </div>

                {/* Floating Data Points */}
                <div className="absolute top-1/4 left-1/6 w-2 h-2 bg-blue-400 rounded-full animate-pulse opacity-40"></div>
                <div className="absolute top-1/3 right-1/5 w-1 h-1 bg-indigo-400 rounded-full animate-pulse opacity-50"></div>
                <div className="absolute bottom-1/3 left-1/5 w-3 h-3 bg-purple-400 rounded-full animate-pulse opacity-30"></div>
                <div className="absolute bottom-1/4 right-1/6 w-2 h-2 bg-cyan-400 rounded-full animate-pulse opacity-45"></div>

                {/* Modern Geometric Patterns */}
                {/* Hexagons */}
                <div className="absolute top-16 right-1/3 w-12 h-12 border-2 border-blue-300 transform rotate-12 animate-float-slow opacity-20">
                    <div className="w-full h-full bg-gradient-to-br from-blue-200 to-transparent"></div>
                </div>
                <div className="absolute bottom-16 left-1/3 w-8 h-8 border-2 border-indigo-300 transform -rotate-12 animate-float-medium opacity-25">
                    <div className="w-full h-full bg-gradient-to-tl from-indigo-200 to-transparent"></div>
                </div>

                {/* Triangles */}
                <div className="absolute top-1/2 right-1/4 w-0 h-0 border-l-8 border-r-8 border-b-12 border-l-transparent border-r-transparent border-b-purple-300 animate-float-fast opacity-20"></div>
                <div className="absolute bottom-1/2 left-1/4 w-0 h-0 border-l-6 border-r-6 border-b-10 border-l-transparent border-r-transparent border-b-cyan-300 transform rotate-45 animate-float-slow opacity-25"></div>

                {/* Modern Rectangles with gradients */}
                <div className="absolute top-24 left-1/5 w-16 h-4 bg-gradient-to-r from-blue-300 to-indigo-300 transform rotate-45 animate-geometric-scale opacity-20"></div>
                <div className="absolute bottom-24 right-1/5 w-12 h-3 bg-gradient-to-r from-purple-300 to-pink-300 transform -rotate-45 animate-float-fast opacity-25"></div>

                {/* Circles with flat design */}
                <div className="absolute top-1/3 left-1/6 w-6 h-6 bg-blue-300 rounded-full animate-float-slow opacity-20"></div>
                <div className="absolute bottom-1/3 right-1/6 w-4 h-4 bg-indigo-300 rounded-full animate-float-medium opacity-25"></div>
                <div className="absolute top-2/3 right-1/5 w-8 h-8 bg-purple-300 rounded-full animate-float-fast opacity-15"></div>

                {/* Abstract geometric shapes */}
                <div className="absolute top-1/4 right-1/6 w-10 h-10 border-2 border-cyan-300 transform rotate-45 animate-geometric-rotate opacity-20">
                    <div className="w-full h-full bg-gradient-to-br from-cyan-200 to-transparent transform -rotate-45"></div>
                </div>
                <div className="absolute bottom-1/4 left-1/6 w-6 h-6 border-2 border-pink-300 transform -rotate-45 animate-float-medium opacity-25">
                    <div className="w-full h-full bg-gradient-to-tl from-pink-200 to-transparent transform rotate-45"></div>
                </div>

                {/* Minimalist lines */}
                <div className="absolute top-1/2 left-1/3 w-20 h-0.5 bg-gradient-to-r from-transparent via-blue-300 to-transparent animate-float-slow opacity-30"></div>
                <div className="absolute bottom-1/2 right-1/3 w-16 h-0.5 bg-gradient-to-r from-transparent via-indigo-300 to-transparent animate-float-medium opacity-25"></div>
                <div className="absolute top-1/6 left-1/2 w-0.5 h-16 bg-gradient-to-b from-transparent via-purple-300 to-transparent animate-float-fast opacity-20"></div>

                {/* Floating geometric dots */}
                <div className="absolute top-1/5 right-1/4 w-2 h-2 bg-blue-400 transform rotate-45 animate-pulse opacity-40"></div>
                <div className="absolute bottom-1/5 left-1/4 w-1 h-1 bg-indigo-400 transform rotate-45 animate-pulse opacity-50"></div>
                <div className="absolute top-3/4 right-1/3 w-3 h-3 bg-purple-400 transform rotate-45 animate-pulse opacity-30"></div>
            </div>
        </div>
    );
};

export default AnimatedBackground;
